import { render } from "./edit.vue?vue&type=template&id=18d989b2"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/tags/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18d989b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18d989b2', __exports__)) {
    console.log('reload')
    api.reload('18d989b2', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=18d989b2", () => {
    console.log('re-render')
    api.rerender('18d989b2', render)
  })

}


export default __exports__